import ajax from '@/utils/ajax';

const header = '/web';
// 通过直播id获取直播推荐(或默认推荐)详情
export const reqliveDetails = (liveId) => ajax(`/web/v1/operation/recommend/live?liveId=${liveId}`);

// 获取直播推荐列表
export const reqliveRecommended = (data) => ajax('/web/v1/product/home/list/1/1', data, 'POST');

// 上传学习进度
export const sendUploadStudyProgress = (data) => ajax('/report/v1/user/course/user/learn/new/report', data, 'POST');

/**
 * 获取回放信息
 * liveId: 直播ID
 */
export const reqGetPlayBack = (data) => ajax(`${header}/v1/user/course/live/replay`, data, 'GET');

// 获取百家云token
export const getBJYToken = (data) => ajax(`${header}/v1/baijiayun/player/token`, data, 'GET');

// 直播间推荐（课程/优惠券）
export const liveRecommends = (data) => ajax(`${header}/v1/operation/recommend/live/new`, data, 'GET');

// 轮询获取直播间推荐（课程/优惠券）
export const liveRecommendPolling = (data) => ajax(`${header}/v1/operation/recommend/live/alert/recommend`, data, 'GET');

// 查询是否开启直播间分组
export const liveBroadcast = (id) => ajax(`${header}/v1/live-broadcast/${id}`);

// 根据直播推荐id获取对应的优惠券领取弹窗信息
export const reqRecommendCoupon = (liveId) => ajax(`${header}/v1/operation/recommend/receive-coupon?liveId=${liveId}`);